import { REQUEST_NPZ} from '../../const';

export default function NpzReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_NPZ:
      return action.npz;
    default:
      return state;
  }
}